import React from "react";
import RoutesComponent from "./app/routes/RoutesComponent";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import KmLogoSvg from "./assets/svgs/kmLogoSvg";
import {Link} from "react-router-dom"

function App() {
    return (
        <>
            <Stack component={"header"} width={"100%"} direction={'row'} justifyContent={'center'} alignItems={'center'}
                   bgcolor={"#fff"} py={2}>
                <a href='https://kalamarket.com'>
                    <KmLogoSvg/>
                </a>
            </Stack>
            <Box component={"div"} width={'100%'} maxWidth={{sm: 980, md: 1800, lg: 1600}} m={"0 auto"}>
                <RoutesComponent/>
            </Box>
        </>
    )
}

export default App;
